import { render, staticRenderFns } from "./viewjobfair.vue?vue&type=template&id=3bc86a85&scoped=true&"
import script from "./viewjobfair.vue?vue&type=script&lang=js&"
export * from "./viewjobfair.vue?vue&type=script&lang=js&"
import style0 from "./viewjobfair.vue?vue&type=style&index=0&id=3bc86a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc86a85",
  null
  
)

export default component.exports